import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { formatToCustomDate, toCapitaliseStringType1 } from '../../../utils/common';
import { logger } from '../../../utils/logger';


const styles = StyleSheet.create({
  page: {
    // fontFamily: 'Arial',
    fontSize: 9,
    padding: 20,
    color: '#000',
  },
  title: {
    fontSize: 12,
    textAlign: 'center',
    textTransform: 'uppercase',
    marginBottom: '18'
  },
  section: {
    marginBottom: 10,
    paddingBottom: 5,
    borderBottom: '1pt solid #ccc',
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: 5,
    fontSize: 11,
    textDecoration: 'underline',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: '0.8rem',
    marginBottom: 5,
    width: '100%',
    justifyContent: 'flex-start',

  },
  field: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',  // This is key
    width: '32%',
    flexBasis: '32%',
    flexShrink: 0,
    marginBottom: 5,

  },
  label: {
    fontWeight: 'bold',
    marginRight: 5,
  },
  value: {
    flexShrink: 1,
    wordBreak: 'break-word',     // For React PDF or Web
    whiteSpace: 'normal',        // For Web
    maxWidth: '100%',            // Avoid overflow 
  },
  Imagefield: {
    width: '20%',
  },
  profilePhoto: {
    height: "100px",
    width: "100%",
    objectFit: "contain",
  },
  Imagerow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },

});


function EmployeeDetailsBlukPDF({
  data,
  orgDetails,
  branchList = [],
  stateList = [],
  organizationFullInfo
}) {
  logger.log(orgDetails, "orgDetails8899")
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>Employee Information Form</Text>
        {/* <View style={styles.section}>
        <View style={styles.Imagerow}>
          <View style={styles.Imagefield}>
            <Text style={[styles.sectionTitle, { width: "100%", textAlign: "center" }]}>Employee Photo</Text>
            <Image
              src={data?.logo ? `data:image/${data?.base64logo?.startsWith('/9j/')?'jpg':'png'};base64,${data?.base64logo}`: ""}
              alt="Employee Photo"
              style={styles.profilePhoto}
            />
          </View>
        </View>
      </View> */}

        {/* <View style={styles.section}>
          <Text style={styles.sectionTitle}>Company Details</Text>
          <View style={styles.row}>
            <View style={styles.field}>
              <Text style={styles.label}>Company Name:</Text>
              <Text style={styles.value}>{orgDetails?.org_name ? orgDetails?.org_name.toUpperCase() : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Company Address:</Text>
              <Text style={styles.value}>{orgDetails?.address ? orgDetails?.address : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Company Number:</Text>
              <Text style={styles.value}>{orgDetails?.phone ? orgDetails?.phone : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Company Email:</Text>
              <Text style={styles.value}>{orgDetails?.email ? orgDetails?.email : '--'}</Text>
            </View>
          </View>
        </View> */}

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Company Details</Text>
          <View style={styles.row}>
            <View style={styles.field}>
              <Text style={styles.label}>Company Name:</Text>
              <Text style={styles.value}>{organizationFullInfo?.org_name ? organizationFullInfo?.org_name.toUpperCase() : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>ESI Number:</Text>
              <Text style={styles.value}>{organizationFullInfo?.esi_code ? organizationFullInfo?.esi_code : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>EPF Number:</Text>
              <Text style={styles.value}>{organizationFullInfo?.epf_organization_number ? organizationFullInfo?.epf_organization_number : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Address:</Text>
              <Text style={styles.value}>{organizationFullInfo?.address ? toCapitaliseStringType1(organizationFullInfo?.address) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>City/District:</Text>
              <Text style={styles.value}>{organizationFullInfo?.city ? toCapitaliseStringType1(organizationFullInfo?.city) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>State:</Text>
              <Text style={styles.value}>{organizationFullInfo?.state ? toCapitaliseStringType1(organizationFullInfo?.state) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Pin code:</Text>
              <Text style={styles.value}>{organizationFullInfo?.pincode ? organizationFullInfo?.pincode : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Country:</Text>
              <Text style={styles.value}>{organizationFullInfo?.country ? toCapitaliseStringType1(organizationFullInfo?.country) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Location:</Text>
              <Text style={styles.value}>{organizationFullInfo?.locality ? toCapitaliseStringType1(organizationFullInfo?.locality) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Company Number:</Text>
              <Text style={styles.value}>{organizationFullInfo?.phone ? organizationFullInfo?.phone : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Company Email:</Text>
              <Text style={styles.value}>{organizationFullInfo?.email ? organizationFullInfo?.email : '--'}</Text>
            </View>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Employee Details</Text>
          <View style={styles.row}>
            <View style={styles.field}>
              <Text style={styles.label}>Employee Name:</Text>
              <Text style={styles.value}>{data?.first_name ? `${data?.first_name?.toUpperCase() + " " + data?.last_name.toUpperCase()}` : "--"}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Employee Type:</Text>
              <Text style={styles.value}>{data?.employment_type
                ? data?.employment_type === "full_time"
                  ? "Permanent"
                  : data?.employment_type === "part_time"
                    ? "Part Time"
                    : data?.employment_type === "probationary"
                      ? "Provision Period"
                      : data?.employment_type === "contractual"
                        ? toCapitaliseStringType1(
                          data?.employment_type
                        )
                        : "--"
                : "--"}{" "}</Text>
            </View>
            <View style={styles.field}><Text style={styles.label}>Salary Type:</Text><Text style={styles.value}> {data?.benefits?.salary_type ? toCapitaliseStringType1(data?.benefits?.salary_type) : '--'}</Text></View>
            <View style={styles.field}>
              <Text style={styles.label}>Date of Joining:</Text>
              <Text style={styles.value}> {data?.join_date ? formatToCustomDate(new Date(data?.join_date)) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Branch Name:</Text>
              <Text style={styles.value}> {data?.branch_id ? toCapitaliseStringType1(
                branchList?.find(
                  (it) => it?.id === data?.branch_id
                )?.name || "N/A"
              ) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Department:</Text>
              {/* <Text style={styles.value}>{data?.department_id ? toCapitaliseStringType1(
                departmentList?.find(
                  (it) => it?.id === data?.department_id
                )?.name || "--"
              ) : '--'}</Text> */}
              <Text style={styles.value}>{data?.department?.dept_name ? data?.department?.dept_name : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Designation:</Text>
              <Text style={styles.value}>{data?.designation?.designation_name ? data?.designation?.designation_name : "--"}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Mobile No:</Text>
              <Text style={styles.value}>{data?.phone ? data?.phone : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Gross Salary:</Text>
              <Text style={styles.value}>
                {data?.salary_info?.gross_salary ? data?.salary_info?.gross_salary : '--'}
              </Text>
            </View>
            {/* {(data?.employee_statutories.length > 0 && data?.employee_statutories?.[0]?.kyc_additional_info) && data?.employee_statutories?.[0]?.kyc_additional_info?.map((item, index) => (
              <>
                <View style={styles.field}>
                  <Text style={styles.label} key={index}>{item?.document_type}:</Text>
                  <Text style={styles.value}>{item?.document_number ? item?.document_number : '--'}</Text>
                </View>
              </>
            ))} */}
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Personal Details</Text>
          <View style={styles.row}>
            <View style={styles.field}>
              <Text style={styles.label}>DOB:</Text><Text style={styles.value}>{data?.date_of_birth ? formatToCustomDate(new Date(data?.date_of_birth)) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Qualification:</Text>
              <Text style={styles.value}>{data?.qualification ? data?.qualification : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Gender:</Text>
              <Text style={styles.value}>{data?.gender ? toCapitaliseStringType1(data?.gender) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Blood Group:</Text>
              <Text style={styles.value}>{data?.blood_group ? data?.blood_group : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Marital Status:</Text>
              <Text style={styles.value}>{data?.marital_status ? toCapitaliseStringType1(data?.marital_status) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Personal Email:</Text>
              <Text style={styles.value}>{data?.personal_email ? data?.personal_email : "--"}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Alternative Phone No:</Text>
              <Text style={styles.value}>{data?.alternative_phone ? data?.alternative_phone : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Guardian Name:</Text>
              <Text style={styles.value}>{data?.guardian_name ? toCapitaliseStringType1(data?.guardian_name) : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Relation With Guardian:</Text>
              <Text style={styles.value}>{data?.guardian_relationship ? toCapitaliseStringType1(data?.guardian_relationship) : '--'}</Text>
            </View>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Bank Details</Text>
          <View style={styles.row}>
          <View style={styles.field}>
              <Text style={styles.label}>Bank Name:</Text>
              <Text style={styles.value}>{data?.bank_name ? data?.bank_name : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Bank A/C No:</Text>
              <Text style={styles.value}>{data?.account_number ? data?.account_number : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Branch Name:</Text>
              <Text style={styles.value}>{data?.branch_name ? data?.branch_name : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>IFSC Code:</Text>
              <Text style={styles.value}>{data?.ifsc_code ? data?.ifsc_code : '--'}</Text>
            </View>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Statutory Details</Text>
          <View style={styles.row}>
            <View style={styles.field}>
              <Text style={styles.label}>EPF Account No:</Text>
              <Text style={styles.value}>{data?.epf_id_ac_no}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>ESI Insurance No:</Text>
              <Text style={styles.value}>{data?.esic_insurance_number ? data?.esic_insurance_number : ''}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>UAN No:</Text>
              <Text style={styles.value}>{data?.uan_no ? data?.uan_no : ''}</Text>
            </View>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Permanent Address</Text>
          <View style={styles.row}>
            <View style={styles.field}>
              <Text style={styles.label}>Address:</Text>
              <Text style={styles.value}>{data?.permanent_address ? data?.permanent_address : "--"}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>City/District:</Text>
              <Text style={styles.value}>{data?.permanent_city ? data?.permanent_city : "--"}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>State:</Text>
              <Text style={styles.value}>{data?.permanent_state ? stateList?.find(
                (it) => it?.id === data?.permanent_state
              )?.state_name || "--" : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>PIN Code:</Text>
              <Text style={styles.value}>{data?.permanent_pincode ? data?.permanent_pincode : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Landmark:</Text>
              <Text style={styles.value}>{data?.permanent_landmark ? data?.permanent_landmark : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Country:</Text>
              <Text style={styles.value}>{data?.permanent_country ? data?.permanent_country : '--'}</Text>
            </View>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Present Address</Text>
          <View style={styles.row}>
            <View style={styles.field}>
              <Text style={styles.label}>Address:</Text>
              <Text wrap style={styles.value}>{data?.present_address ? data?.present_address : "--"}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>City/District:</Text>
              <Text style={styles.value}>{data?.present_city ? data?.present_city : "--"}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>State:</Text>
              <Text style={styles.value}>{data?.present_state ? stateList?.find(
                (it) => it?.id === data?.present_state
              )?.state_name || "--" : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>PIN Code:</Text>
              <Text style={styles.value}>{data?.present_pincode ? data?.present_pincode : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Landmark:</Text>
              <Text style={styles.value}>{data?.present_landmark ? data?.present_landmark : '--'}</Text>
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Country:</Text>
              <Text style={styles.value}>{data?.permanent_country ? data?.permanent_country : '--'}</Text>
            </View>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Nominee Details</Text>
          {data?.employee_nominee?.length > 0 && data?.employee_nominee?.map((item, index) => (
            <>
              <View style={styles.row} key={index}>
                <View style={styles.field}>
                  <Text style={styles.label}>Nominee Name:</Text>
                  <Text style={styles.value}>{item?.name ? toCapitaliseStringType1(item?.name) : '--'}</Text>
                </View>
                <View style={styles.field}>
                  <Text style={styles.label}>Relationship:</Text>
                  <Text style={styles.value}>{item?.relationship ? item?.relationship : '--'}</Text>
                </View>
                <View style={styles.field}>
                  <Text style={styles.label}>DOB:</Text>
                  <Text style={styles.value}>
                    {item?.date_of_birth ? formatToCustomDate(new Date(item?.date_of_birth)) : '--'}</Text>
                </View>
              </View>
            </>
          ))}
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Family Details</Text>
          {data?.employee_family?.length > 0 && data?.employee_family?.map((family, index) => (
            <>
              <View style={styles.row} key={index}>
                <View style={styles.field}>
                  <Text style={styles.label}>Name:</Text>
                  <Text style={styles.value}>{family?.name ? toCapitaliseStringType1(family?.name) : '--'}</Text>
                </View>
                <View style={styles.field}>
                  <Text style={styles.label}>Relation:</Text>
                  <Text style={styles.value}>{family?.relationship ? family?.relationship : '--'}</Text>
                </View>
                <View style={styles.field}>
                  <Text style={styles.label}>DOB:</Text>
                  <Text style={styles.value}>{family?.date_of_birth ? formatToCustomDate(new Date(family?.date_of_birth)) : '--'}</Text>
                </View>
                <View style={styles.field}>
                  <Text style={styles.label}>Phone No:</Text>
                  <Text style={styles.value}>{(family?.contact_no) ? family?.contact_no: '--'}</Text>
                </View>
                <View style={styles.field}>
                  <Text style={styles.label}>Address:</Text>
                  <Text style={styles.value}>{family?.address ? family?.address : '--'}</Text>
                </View>
              </View>
            </>
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default EmployeeDetailsBlukPDF;